export const LOCALES = {
    ENGLISH: 'en',
    GERMAN: 'de',
    FRENCH: 'fr',
}